import { render } from "./question_select.vue?vue&type=template&id=09121d2e"
import script from "./question_select.vue?vue&type=script&lang=js"
export * from "./question_select.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__